<div *ngIf='authToken$ | async'>
  <atlas-footer [brandUrl]="brandUrl" [brandIcon]="brandIcon" [brandIconCollection]="brandIconCollection"
    [brandIconSize]="brandIconSize" [brandIconColor]="brandIconColor" [brandLogoMode]="brandLogoMode"
    [businessLinks]="mercerBusinessLinks" [socialIcons]="mercerSocialIcons" [legalLinks]="mercerLegalLinks"
    [description]="''" [copyright]="copyright" (click)="onFooterClick($event)"></atlas-footer>


  <atlas-modal [size]="modalSize" [showDialogActions]="false" [disableClose]="false" #termsModal
    [headerRef]="termsModalheader" [contentRef]="termsModalcontent">
  </atlas-modal>
  <ng-template #termsModalheader>
    <div class='terms-of-use'>
      <h4>Terms & Conditions
      </h4>

      <atlas-icon class="dsp-print-icon" (click)="termsAndConditions('termsAndConditionDivId')" [icon]="'print'"
        [size]="'large'" [collection]="'technology-solid'">
      </atlas-icon>
    </div>
  </ng-template>
  <ng-template #termsModalcontent>
    <div id="termsAndConditionDivId" [innerHTML]="terms$ | async">
    </div>
  </ng-template>
  <atlas-modal [size]="modalSize" [showDialogActions]="false" [disableClose]="false" #disclaimersModal
    [headerRef]="disclaimersModalheader" [contentRef]="disclaimersModalcontent">
  </atlas-modal>
  <ng-template #disclaimersModalheader>
    <h4>Disclaimers</h4>
  </ng-template>
  <ng-template #disclaimersModalcontent>
    <div class="disclaimer-data" [innerHTML]="disclaimers$ | async">
    </div>
  </ng-template>
</div>